/**
 * The purpose of this file is to regroup the other modules to bring about the view for the
 * primeng elements used throughout the application.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedPrimengModule } from './shared-primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    SharedPrimengModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
  ],

  exports: [
    SharedPrimengModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
  ],
})
export class SharedModule {}
